import { Box, Stack } from '@mui/material'
import { FC, useContext } from 'react'

import { CenteredLoading } from '../../components'
import { DviListContext } from '../../providers/DviListProvider/DviListProvider'
import InspectionCard from '../DviInspections/InspectionCard'
import { DviUnassignedInspection } from './DviUnassignedInspection'

const DviHomeInspectionList: FC = () => {
  const { inspections, repairOrderLookup, isLoading } =
    useContext(DviListContext)

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{ overflowX: 'scroll', width: '100%' }}>
      {isLoading || !inspections ? (
        <CenteredLoading />
      ) : inspections.length !== 0 ? (
        [...inspections]
          .filter(
            (inspection) => !!repairOrderLookup[inspection.info!.repairOrder!]
          )
          .reverse()
          .map((inspection) => (
            <Box key={inspection.id!} minWidth={300}>
              <InspectionCard
                {...{ inspection }}
                repairOrder={repairOrderLookup[inspection.info!.repairOrder!]}
                key={inspection.id}
              />
            </Box>
          ))
      ) : (
        <DviUnassignedInspection />
      )}
    </Stack>
  )
}

export default DviHomeInspectionList
